/**
 * Checks if a user subscription is active and returns status with any error information
 * @param {Object} sub - The subscription object to check
 * @returns {Object} - Contains isActive status and any error information
 */
export const isSubActive = (sub) => {
    // Handle null/undefined userSub case
    if (!sub) {
        return {
            isActive: false,
            error: "No subscription data available"
        };
    }

    // Handle invalid object case
    if (typeof sub !== 'object') {
        return {
            isActive: false,
            error: "Invalid subscription data format"
        };
    }

    // Check if the subscription object has the required properties
    const { subscription_status, current_period_end } = sub;

    if (!subscription_status || !current_period_end) {
        return {
            isActive: false,
            error: "Missing required subscription information"
        };
    }

    const inactiveStatuses = new Set([
        "incomplete",
        "incomplete_expired",
        "past_due",
        "canceled",
        "unpaid",
        "paused",
    ]);

    const endDate = new Date(current_period_end * 1000); // Convert to milliseconds
    const isActive = !inactiveStatuses.has(subscription_status) && endDate > Date.now();

    return {
        isActive,
        error: null
    };
};